/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Universal1Inputs */

const id_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel dengan Apple Silicon dan Intel Mac.`)
};

const ms_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serasi dengan kedua-dua Apple Silicon dan Intel Mac.`)
};

const da_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel med både Apple Silicon og Intel Macs.`)
};

const de_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel mit Apple Silicon und Intel Macs.`)
};

const en_us2_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatible with both Apple Silicon and Intel Macs.`)
};

const es_es2_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatible con Mac tanto Apple Silicon como Intel.`)
};

const es_mx2_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatible con Mac tanto Apple Silicon como Intel.`)
};

const fil_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katugma sa parehong Apple Silicon at Intel Macs.`)
};

const fr_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatible avec les Mac Apple Silicon et Intel.`)
};

const it_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibile sia con Apple Silicon che con Mac Intel.`)
};

const hu_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibilis mind Apple Silicon, mind Intel Mac gépekkel.`)
};

const nl_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibel met zowel Apple Silicon als Intel Macs.`)
};

const no_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel med både Apple Silicon og Intel Mac-er.`)
};

const pl_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodne zarówno z Apple Silicon, jak i Intel Mac.`)
};

const pt_br2_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatível com Apple Silicon e Intel Macs.`)
};

const pt_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatível com Apple Silicon e Intel Mac.`)
};

const ro_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibil atât cu Apple Silicon cât și cu Intel Mac.`)
};

const fi_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteensopiva sekä Apple Silicon- että Intel-Macien kanssa.`)
};

const sv_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel med både Apple Silicon och Intel Mac.`)
};

const vi_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tương thích với cả Apple Silicon và Mac Intel.`)
};

const tr_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hem Apple Silicon hem de Intel Mac'lerle uyumlu.`)
};

const cs_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibilní s Apple Silicon i Intel Mac.`)
};

const bg_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Съвместим с Apple Silicon и Intel Mac.`)
};

const ru_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместимо с Apple Silicon и Intel Mac.`)
};

const uk_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сумісно з Apple Silicon та Intel Mac.`)
};

const ar_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوافق مع Apple Silicon و Intel Mac.`)
};

const hi_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple Silicon और Intel Mac दोनों के साथ संगत।`)
};

const th_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้ากันได้กับทั้ง Apple Silicon และ Intel Mac`)
};

const ja_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple Silicon と Intel Mac の両方に対応。`)
};

const zh_cn2_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同时兼容 Apple Silicon 和 Intel Mac。`)
};

const zh_hant1_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同時相容 Apple Silicon 和 Intel Mac。`)
};

const ko_misc_downloads_assetinfo_universal1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Universal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple Silicon 및 Intel Mac 모두와 호환됩니다.`)
};

/**
* | output |
* | --- |
* | "Compatible with both Apple Silicon and Intel Macs." |
*
* @param {Misc_Downloads_Assetinfo_Universal1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_universal1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Universal1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Universal1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_universal1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_universal1(inputs)
	return ko_misc_downloads_assetinfo_universal1(inputs)
});
export { misc_downloads_assetinfo_universal1 as "misc.downloads.assetInfo.universal" }